import React from 'react'
import styled from 'styled-components'

const Card = styled.button<{ $selected: boolean }>`
  width: 100%;
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  appearance: none;
  border: 1px solid
    ${({ $selected }) =>
      $selected ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 0.5rem;
  background-color: ${({ $selected }) =>
    $selected ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.04)'};
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.forecast.activeText};
    outline-offset: 2px;
  }
`

const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`

const Title = styled.h3`
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: inherit;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export function getIndicationGroupLabel(index: number): string {
  return `Indication Group ${index + 1}`
}

export function IndicationGroupCard({
  label,
  badge,
  selected,
  onSelect,
  children,
}: {
  label: React.ReactNode
  badge?: React.ReactNode
  selected: boolean
  onSelect: () => void
  children: React.ReactNode
}) {
  return (
    <Card
      type='button'
      $selected={selected}
      aria-pressed={selected}
      onClick={onSelect}>
      <Header>
        <Title>{label}</Title>
        {badge}
      </Header>
      {children}
    </Card>
  )
}
